export const FRAGMENT_PADDING_X = 10;
export const FRAGMENT_MIN_WIDTH = 100;
export const MARGIN = 20;
export const ARROW_HEAD_WIDTH = 10;
export const OCCURRENCE_WIDTH = 15;
export const OCCURRENCE_BAR_SIDE_WIDTH = (OCCURRENCE_WIDTH - 1) / 2; // Width of each side of the occurrence bar

// also used in css `.zenuml .participant { min-width: 88px; }`
export const MIN_PARTICIPANT_WIDTH = 80;
export const PARTICIPANT_HEIGHT = 70;
// Width allocated for the icon column on the left of an iconed participant.
export const PARTICIPANT_ICON_WIDTH = 40;

export const LIFELINE_WIDTH = 1;

// Height constants for calculated positioning
export const STATEMENT_CONTAINER_MARGIN = 16; // my-4 class = margin-y: 1rem
export const COMMENT_LINE_HEIGHT = 20;
export const MESSAGE_HEIGHT = 16; // sync/async/return messages
export const CREATION_MESSAGE_HEIGHT = 62; // creation message total height
export const SELF_INVOCATION_SYNC_HEIGHT = 55; // 16px message + 24px SVG
export const SELF_INVOCATION_ASYNC_HEIGHT = 54; // 20px message + 34px SVG
export const FRAGMENT_HEADER_HEIGHT = 25;
export const FRAGMENT_BORDER_WIDTH = 1;
export const FRAGMENT_MARGIN = 16;
export const FRAGMENT_PADDING_BOTTOM = 10;
export const PARTICIPANT_TOP_SPACE_FOR_GROUP = 20;
export const CREATION_LIFELINE_OFFSET = 48;
export const OCCURRENCE_WITH_CHILDREN_HEIGHT = 20;
export const OCCURRENCE_EMPTY_HEIGHT = 24;
